/* tslint:disable */
export var FeedbackSource;
(function (FeedbackSource) {
    FeedbackSource[FeedbackSource["LOH_INGAME"] = 1] = "LOH_INGAME";
    FeedbackSource[FeedbackSource["INGAME_FEEDBACK"] = 2] = "INGAME_FEEDBACK";
    FeedbackSource[FeedbackSource["RATING_FEEDBACK"] = 3] = "RATING_FEEDBACK";
})(FeedbackSource || (FeedbackSource = {}));
/* tslint:enable */



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/types/FeedbackSourceEnum.ts
// module id = 1692
// module chunks = 3